import { OperationId, operations } from '@/app/workflows/components/v6/operations/operations';
import { getEnabledOperations } from '@/app/workflows/actions/utils/getEnabledOperations';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { getDefaultSettingValue } from '@/app/workflows/actions/constants/blankWorkflow';
import { notNull } from '@/utils/notNull';
import { OperationsFormValues } from '@/app/workflows/components/v6/operations/settings/form/schema';
import { UseFormReturnType } from '@mantine/form';
import { GrowthbookFeature, useGrowthbookContext } from '@/app/contexts/GrowthbookContext';

export const useOperationListHandlers = (workflow: Workflow, form: UseFormReturnType<OperationsFormValues>) => {
  const growthbook = useGrowthbookContext();
  const features: GrowthbookFeature[] = growthbook?.isOn('show-uvunwrap') ? ['show-uvunwrap'] : [];

  const onEnabledOperationChanged = (id: OperationId, enabled: boolean) => {
    const enabledOperations = getEnabledOperations(id, enabled, workflow);
    const newValues: Partial<OperationsFormValues> = form.values;

    for (const operation of operations) {
      if (enabledOperations.includes(operation.id)) {
        // @ts-ignore
        const currentFormValue = form.values[operation.id];
        if (!notNull(currentFormValue)) {
          const defaultValue = getDefaultSettingValue(operation.id, features);
          // @ts-ignore
          newValues[operation.id] = defaultValue;
        }
      } else {
        // @ts-ignore
        delete newValues[operation.id];
      }
    }

    form.setValues(newValues);
  };

  return {
    onEnabledOperationChanged,
  };
};
